var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{scopedSlots:_vm._u([{key:"start",fn:function(){return [_c('strong',[_vm._v(" "+_vm._s(_vm.$tera.project.name ? _vm.$tera.project.name : "Untitled Methods Section")+" ")]),_c('TheArticleCitation',{attrs:{"title":_vm.$tera.project.name,"authors":_vm.$tera.project.authors,"year":_vm.$tera.project.year}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }